import * as types from '@/store/notification/actionTypes';
// eslint-disable-next-line import/no-cycle
import {
  deleteNotification,
  deleteNotificationForSP, getNotifications,
  getNotificationsForSP, updateNotificationStatus,
  updateNotificationStatusForSP,
} from '@/services/repository';
import { CLEAR_NOTIFICATIONS, SET_NOTIFICATIONS, SET_UNREAD_NOTIFICATIONS } from '@/store/notification/mutationTypes';

export default {
  async [types.DELETE_NOTIFICATION]({ dispatch, getters }, options) {
    try {
      if (getters.auth['cognito:groups'].includes('SPWorker') ||
        getters.auth['cognito:groups'].includes('SPFreelancer') ||
        getters.auth['cognito:groups'].includes('SPAdmin')) {
        await deleteNotificationForSP(options);
      } else {
        await deleteNotification(options);
      }
      await dispatch(types.LOAD_NOTIFICATIONS);
    } catch (e) {
      console.error('delete notification error:', e);
      throw e;
    }
  },

  async [types.LOAD_NOTIFICATIONS]({ commit, getters }, options) {
    try {
      let notifications = [];
      if (getters.auth['cognito:groups'].includes('SPWorker') ||
        getters.auth['cognito:groups'].includes('SPFreelancer') ||
        getters.auth['cognito:groups'].includes('SPAdmin')) {
        notifications = await getNotificationsForSP(options);
      } else {
        notifications = await getNotifications(options);
      }
      commit(SET_NOTIFICATIONS, notifications);
      const unreadNotifications = [];
      Array.from(notifications).forEach(notification => {
        if (notification.status === 'unread') {
          unreadNotifications.push(notification);
        }
      });
      commit(SET_UNREAD_NOTIFICATIONS, unreadNotifications);
    } catch (e) {
      console.error('getting notification error:', e);
      commit(CLEAR_NOTIFICATIONS);
      throw e;
    }
  },

  async [types.UPDATE_NOTIFICATION_STATUS]({ dispatch, getters }, options) {
    try {
      if (getters.auth['cognito:groups'].includes('SPWorker') ||
        getters.auth['cognito:groups'].includes('SPFreelancer') ||
        getters.auth['cognito:groups'].includes('SPAdmin')) {
        await updateNotificationStatusForSP(options);
      } else {
        await updateNotificationStatus(options);
      }
      await dispatch(types.LOAD_NOTIFICATIONS);
    } catch (e) {
      console.error('updating notification status error:', e);
      throw e;
    }
  },
};
